/**
 * bloomsTaxonomy.ts
 * Bloom's Taxonomy level metadata and helpers.
 */

import type { BloomsLevel } from '@types-local/quiz.types';

export interface BloomsInfo {
  level: BloomsLevel;
  order: number;         // 1 (lowest) → 6 (highest)
  color: string;         // Tailwind bg class
  description: string;
  verbs: string[];       // common action verbs for this level
}

export const BLOOMS_INFO: Record<BloomsLevel, BloomsInfo> = {
  Remember: {
    level: 'Remember',
    order: 1,
    color: 'bg-blue-500',
    description: 'Recall facts and basic concepts',
    verbs: ['define', 'list', 'recall', 'repeat', 'state', 'name'],
  },
  Understand: {
    level: 'Understand',
    order: 2,
    color: 'bg-teal-500',
    description: 'Explain ideas or concepts',
    verbs: ['describe', 'explain', 'summarize', 'classify', 'identify'],
  },
  Apply: {
    level: 'Apply',
    order: 3,
    color: 'bg-green-500',
    description: 'Use information in new situations',
    verbs: ['solve', 'use', 'demonstrate', 'calculate', 'execute'],
  },
  Analyze: {
    level: 'Analyze',
    order: 4,
    color: 'bg-yellow-500',
    description: 'Draw connections among ideas',
    verbs: ['compare', 'differentiate', 'organize', 'question', 'examine'],
  },
  Evaluate: {
    level: 'Evaluate',
    order: 5,
    color: 'bg-orange-500',
    description: 'Justify a decision or course of action',
    verbs: ['argue', 'defend', 'judge', 'select', 'support', 'critique'],
  },
  Create: {
    level: 'Create',
    order: 6,
    color: 'bg-purple-500',
    description: 'Produce new or original work',
    verbs: ['design', 'assemble', 'construct', 'produce', 'develop'],
  },
};

export const BLOOMS_LEVELS: BloomsLevel[] = [
  'Remember', 'Understand', 'Apply', 'Analyze', 'Evaluate', 'Create',
];

export function getBloomsInfo(level: BloomsLevel): BloomsInfo {
  return BLOOMS_INFO[level];
}
